import { memo, useEffect, useMemo } from 'react';
import { buildHandleId } from '../../lib/utils';
import { HANDLES_TYPES, NODES_TYPES } from '../../types';
import { useUpdateNodeInternals } from '@xyflow/react';
import CustomNode from './CustomNode';
import HandlesWrapper from '../HandlesWrapper';
import styles from '../../timeline-node-manager.module.css';
import { getConditionNodeLabel } from './nodeLabelUtils';

interface ConditionNodeProps {
  id: string;
  data: any;
  type: NODES_TYPES;
  selected: boolean;
}

const ConditionNode = ({ id, data, type, selected }: ConditionNodeProps) => {
  const updateNodeInternals = useUpdateNodeInternals();

  const nodeLabel = useMemo(() => {
    return getConditionNodeLabel(data);
  }, [data.type, data.params?.interactionType]);

  useEffect(() => {
    updateNodeInternals(id);
  }, [data]);

  return (
    <CustomNode
      id={id}
      type={type}
      data={data}
      label={nodeLabel}
      containerClassname={styles.conditionNode}
      selected={selected}
    >
      <HandlesWrapper
        sources={[
          {
            id: buildHandleId({
              type: 'input',
              handleType: HANDLES_TYPES.EVENT,
              nodeId: id,
            }),
            label: 'Event',
          },
        ]}
      />
    </CustomNode>
  );
};

export default memo(ConditionNode);
